export const SKILL_ADVANCED = 'advanced';
export const SKILL_GOOD = 'good';
export const SKILL_BASIC = 'basic';